import { createStore } from 'vuex'

export default createStore({
  state: {
    player: false,
    playing: true,
    navbar: false,
    id_fs: 0,
    nots: false,
    show_app: false
  },
  getters: {
  },
  mutations: {
    storeNot(state, data){
      state.nots = data
    },
    storeP(state, data){
      state.player = data
    },
    showApp(state, data){
      state.show_app = data
    }
  },
  actions: {
    delPlayer(store){
      store.commit('storeP', false)
			const audio = document.getElementById('audio')
			audio.remove()
			const app = document.getElementById('app');
			app.insertAdjacentHTML("beforeend", '<audio id="audio"></audio>')
		},
    getNot(state, data){
      const notification = new Notification(data.title, {
        body: data.text,
        icon: 'https://habborank.pauloferraco.com.br/img/favicon.png',
        lang: "pt-br",
        tag: 'ao-vivo',
        renotify: true
      })
      notification
    }
  },
  modules: {
  }
})
